// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"MJUlDd"};